export const getFileType = (file: File) => {
  const type = file.type.split('/')[0];

  if (type === 'image' || type === 'video' || type === 'audio') {
    return type;
  }

  return null;
};
